import React, { useContext, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { ApiContext } from '../../../UseContext/ApiCall';
import { AwsFileUrl, BASE_URL_STATIC } from '../../../../../config';



const CnpMemePopup = () => {

  const {
    // ----- Create New Post > Text -----
    cnpText, setCnpText,
    
    loggedInUser,
    cnpSelectedLocation, 
    setShowCnpLocationPopup,
    setShowCnpTagPopup,
    setCnpTagAxis,
    showCnpTagsOnPhoto, setShowCnpTagsOnPhoto,
    cnpSelectedMusic,
    selectedMusicPlaying,
    setSelectedMusicPlaying,
    setShowCnpSelectMusicPopup,
    getMusics,
    cnpMusics,
    setCnpSelectedMusic,
    setCnpSelectedLocation,
    setShowCnpFeelingActivityPopup,
    setCnpFeelingActivityTab,
    getActivities,
    getFeelings,
    createNewPost,
    handleRemoveTaggedUser,
    cnpSelectedPhotoVideo, setCnpSelectedPhotoVideo,
    setShowCreateNewPostPopup,
    setCnpPreviouslyOpenedPopup,
    cnpSelectedFeeling,
    cnpSelectedActivityCategory,
    cnpSelectedActivity,

    // ----- Advance Setting -----
    setShowCnpAdvanceSettingPopup,
    getCnpAdvanceSetting,

    showCnpMemePopup, setShowCnpMemePopup,
  } = useContext(ApiContext);



  // ----- Meme -----

  const [isVideoMuted, setIsVideoMuted] = useState(false);

  const memeRef = useRef(null);

  // handle click meme
  const handleClickMeme = () => {
    memeRef.current.click(); 
  };

  // handle meme file change
  const handleMemeFileChange = (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    const file = files[0];

    // console.log('file : ', file);

    setCnpSelectedPhotoVideo([{
      file,
      tags: [],
      fileType: file.type.startsWith('image/') ? 'image' : 'video',
    }]);
  };



  // ----- Location -----

  // handle click location
  const handleClickLocation = () => {
    setShowCnpMemePopup(false);
    setShowCnpLocationPopup(true);
  };


  // ----- Tag -----

  // handle tag on photo
  const handleTagOnPhoto = (e, index) => {
    setShowCnpTagPopup(true);
  
    const img = e.target;
    const rect = img.getBoundingClientRect();
  
    const percentX = ((e.clientX - rect.left) / rect.width) * 100;
    const percentY = ((e.clientY - rect.top) / rect.height) * 100;
  
    setCnpTagAxis({ index, offsetX: percentX, offsetY: percentY });
  };

  // handle click photo tag icon
  const handleClickPhotoTagIcon = () => {
    setShowCnpTagsOnPhoto(!showCnpTagsOnPhoto);
  };

  // handle click video tag icon
  const handleClickVideoTagIcon = (photoVideoIndex) => {
    setCnpTagAxis({
      index: photoVideoIndex,
      offsetX: '',
      offsetY: '',
    });

    setShowCnpTagPopup(true);
  };


  // ----- Music -----

  const musicRef = useRef(new Audio());

  // handle click music
  const handleClickMusic = () => {
    setShowCnpMemePopup(false);
    setShowCnpSelectMusicPopup(true);

    getMusics('', cnpMusics.length, 10);
  };

  // handle play/pause music
  const handlePlayPauseMusic = () => {
    if (selectedMusicPlaying) {
      musicRef.current.pause();
      setSelectedMusicPlaying(false);
    } else {
      musicRef.current.src = cnpSelectedMusic.audio;
      musicRef.current.play();
      setSelectedMusicPlaying(true);
    };
  };

  // handle remove music
  const handleRemoveMusic = () => {
    setCnpSelectedMusic({});

    musicRef.current.pause();
    
    setSelectedMusicPlaying(false);

    // show location image if location selected when user remove music
    if(cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null) {
      setCnpSelectedLocation(preState => ({
        ...preState,
        placeImage: true
      }));
    };
  };
  

  // ----- text -----

  // handle text change
  const handleTextChange = (e) => {
    const { value } = e.target;

    setCnpText(value);
  };


  // ----- Feeling/Activity -----

  // handle click feeling/activity
  const handleClickFeelingActivity = () => {

    setShowCnpMemePopup(false);
    setShowCnpFeelingActivityPopup(true);
    
    if(cnpSelectedActivityCategory._id) {
      setCnpFeelingActivityTab('activity');

      getActivities(cnpSelectedActivityCategory._id, '', 0);
    } else {
      setCnpFeelingActivityTab('feeling');

      getFeelings('', 0);
    };
  };


  // ----- Options > Delete/Remove -----
 
  // handle click meme delete icon
  const handleClickMemeDeleteIcon = () => {
    setCnpSelectedPhotoVideo([]);
  };

  // handle click video play/pause
  const handleClickVideoPlayPause = (e) => {
    const video = e.target;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    };
  };

  // handle click video mute/unmute
  const handleClickVideoMuteUnmute = () => {
    setIsVideoMuted(!isVideoMuted);
  };


  // handle post meme
  const handlePostMeme = () => {
    createNewPost('meme');
  };

  // handle click advance setting
  const handleClickAdvanceSetting = () => {
    setShowCnpMemePopup(false);
    setShowCnpAdvanceSettingPopup(true);
    getCnpAdvanceSetting('meme');
  };

  // handle close meme popup 
  const handleCloseMemePopup = () => {
    setShowCnpMemePopup(false);
    setShowCreateNewPostPopup(true);
    setCnpPreviouslyOpenedPopup('createNewPost');
  };


  return (
    <>
      <Modal show={showCnpMemePopup} onHide={handleCloseMemePopup} centered backdrop="static" keyboard={false} className="main-modal cnp-meme-popup" >
      {/* <Modal show={true} onHide={handleCloseMemePopup} className="main-modal cnp-meme-popup" centered backdrop="static" keyboard={false} > */}
        <Modal.Header className='mb-3 pt-0' closeButton>
          <div className='text-center mt-3 w-100'>
            <img src="/images/meme-logo.png" style={{ height: '50px' }} alt="meme" />
          </div>
        </Modal.Header>

        <Modal.Body className='pt-1'>
          {/* Profile, Name, Feeling, Activity & Check in/Location */}
          <>
            {
              loggedInUser 
              &&
              <div className='d-flex align-items-center gap-3'>
                {/* Profile */}
                <img src={loggedInUser.profileImg && loggedInUser.profileImg.imageId && AwsFileUrl+loggedInUser.profileImg.imageId} className='border rounded-circle' style={{ height: '45px', width: '45px' }} alt='profile' />

                <div className='text-white'>
                  {/* Name, Feeling, Activity & Check in/Location */}
                  <div>
                    {/* Name */}
                    <span className='fs-5'>{loggedInUser.fname} {loggedInUser.lname}</span> {' '}

                    {/* Feeling */}
                    <>
                      {
                        (cnpSelectedFeeling && cnpSelectedFeeling._id)
                        &&
                        <>
                          <span className='text-secondary'>is</span> {' feeling '}
                          {cnpSelectedFeeling.feelingName} {' '}
                          <img src={cnpSelectedFeeling.feelingIcon} style={{ height: '17px', width: '17px' }} alt="icon" />
                          {' '}
                        </>
                      }
                    </>

                    {/* Activity */}
                    <>
                      {
                        (cnpSelectedActivityCategory && cnpSelectedActivityCategory._id)
                        &&
                        (cnpSelectedActivity && cnpSelectedActivity._id)
                        &&
                        <>
                          <span className='text-secondary'>is</span> {' '}
                          {cnpSelectedActivityCategory.activityCategoryName} {' '}
                          <img src={cnpSelectedActivityCategory.activityCategoryIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {' '}
                          {cnpSelectedActivity.activityName} {' '}
                          <img src={cnpSelectedActivity.activityIcon} style={{ height: '17px', width: '17px' }} alt="icon" /> {' '}
                        </>
                      }
                    </>

                    {/* Check in/Location */}
                    <>
                      {
                        (cnpSelectedLocation.place !== '' && cnpSelectedLocation.lat !== null && cnpSelectedLocation.lng !== null)
                        &&
                        <>
                          <span className='text-secondary'>at</span> {' '}
                          {cnpSelectedLocation.place.split(" ").slice(0, 5).join(" ")}
                          {cnpSelectedLocation.place.split(" ").length > 5 && "..."}
                        </>
                      }
                    </>
                  </div>

                  {/* Add Location */}
                  <>
                    {
                      (cnpSelectedLocation.place === '' && cnpSelectedLocation.lat === null && cnpSelectedLocation.lng === null)
                      &&
                      <div className='cursor-pointer' onClick={handleClickLocation}>
                        <img src={`/images/icons/location-white.svg`} className='me-1' style={{ height: '15px', width: '15px' }} alt="location" />
                        <span>Add Location</span>
                      </div>
                    }
                  </>
                </div>
              </div>
            }
          </>

          {/* Options > Play/Pause, Mute/Unmute & Delete */}
          <div className='d-flex justify-content-end gap-3 my-3'>
            {/* Mute/Unmute */}   
            <>
              {
                (cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length > 0 && cnpSelectedPhotoVideo[0].file && cnpSelectedPhotoVideo[0].file.type.includes('video'))
                &&
                <div className='bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={handleClickVideoMuteUnmute}>
                  <img src={`/images/icons/${isVideoMuted ? 'mute' : 'unmute'}-white.svg`} style={{ height: '17px', width: '17px', cursor: 'pointer' }} alt="tag" />
                </div>
              }
            </>             

            {/* Delete */}
            <div className='bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={handleClickMemeDeleteIcon}>
              <img src="/images/icons/delete-white.svg" style={{ height: '17px', width: '17px', cursor: 'pointer' }} alt="tag" />
            </div>
          </div>

          {/* Meme > Click here to add meme */}
          <>
            {
              (cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length === 0)
              &&
              <div className='border rounded-4 my-3 d-flex flex-column align-items-center justify-content-center gap-2 cursor-pointer' style={{ height: '200px' }} onClick={handleClickMeme} >
                <img src="/images/icons/add-gallary.svg" style={{ height: '75px', width: '75px' }} alt="addGallary" />
                <span className='text-white'>Click here to add meme</span>
                <input type="file" ref={memeRef} style={{ display: 'none' }} accept="image/*,video/*" onChange={handleMemeFileChange} />
              </div>
            }
          </>

          {/* Meme > Photo */}
          <>
            {
              (cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length > 0 && cnpSelectedPhotoVideo[0].file && cnpSelectedPhotoVideo[0].file.name && cnpSelectedPhotoVideo[0].file.type.includes('image'))
              &&
              <div className='border border-white text-center rounded-4' style={{ height: '200px' }}>
                <div className='d-inline-block position-relative h-100'>
                  <>
                    <img src={URL.createObjectURL(cnpSelectedPhotoVideo[0].file)} className='h-100' style={{ cursor: 'crosshair' }} onClick={(e) => handleTagOnPhoto(e, 0)} alt="photoVideo" />

                    {/* Tags */}
                    <>
                      {
                        (showCnpTagsOnPhoto && cnpSelectedPhotoVideo[0].tags && cnpSelectedPhotoVideo[0].tags.length > 0)
                        &&
                        cnpSelectedPhotoVideo[0].tags.map((tagValue, tagIndex) => (
                          <div className='position-absolute pt-1 px-2 bg-secondary rounded-2 d-flex align-items-center gap-2 text-white' key={tagIndex}
                            style={{ 
                              top: `${tagValue.offsetY}%`, 
                              left: `${tagValue.offsetX}%`, 
                              zIndex: `${tagIndex}`,
                              fontSize: '13px',
                              transform: 'translate(-50%, -0%)'
                            }} 
                          >
                            <span>{tagValue.userName}</span>
                            <span className='cursor-pointer' onClick={() => handleRemoveTaggedUser(0, tagIndex)}>✖</span>
                          </div>
                        ))
                      }
                    </>

                    {/* Tag Icon */}
                    <div className='position-absolute start-0 bottom-0 ms-2 mb-2 bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={handleClickPhotoTagIcon}>
                      <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                    </div>
                  </>
                </div>
              </div>
            }
          </>

          {/* Meme > Video */}
          <>
            {
              (cnpSelectedPhotoVideo && cnpSelectedPhotoVideo.length > 0 && cnpSelectedPhotoVideo[0].file && cnpSelectedPhotoVideo[0].file.type.includes('video'))
              &&
              <div className='border border-white text-center rounded-4' style={{ height: '200px' }}>
                <div className='d-inline-block position-relative h-100'>
                  <>
                    <video 
                      src={URL.createObjectURL(cnpSelectedPhotoVideo[0].file)} 
                      className='rounded-0'
                      onClick={handleClickVideoPlayPause} 
                      muted={isVideoMuted} 
                      loop 
                    />

                    {/* Tag Icon */}
                    <div className='position-absolute start-0 bottom-0 ms-2 mb-2 bg-secondary px-2 pb-1 rounded-circle cursor-pointer shadow-sm' onClick={() => handleClickVideoTagIcon(0)}>
                      <img src="/images/icons/user-white.svg" style={{ height: '15px', width: '15px', cursor: 'pointer' }} alt="tag" />
                    </div>
                  </>
                </div>
              </div>
            }
          </>

          {/* Music text (jb music selected h lekin music image show nhi krna h tb ye show krna h) */}
          <>
            {
              (cnpSelectedMusic && cnpSelectedMusic.id && cnpSelectedMusic.id !== '')
              &&
              <div className='my-3 d-flex align-items-center gap-3'>
                <img src="/images/icons/music.svg" style={{ height: '17px', width: '17px' }} alt="music" />

                <span className='me-auto text-truncate text-white'>{cnpSelectedMusic.name}</span>

                {/* Play/Pause */}
                <img src={selectedMusicPlaying ? "/images/icons/pause-white.svg" : "/images/icons/play-white.svg"} 
                  className='cursor-pointer' style={{ height: '20px', width: '20px' }} onClick={handlePlayPauseMusic} alt='playPause'
                />

                {/* Remove */}
                <img src="/images/icons/close-circle-white.svg" className='cursor-pointer' style={{ height: '25px', width: '25px' }} onClick={handleRemoveMusic} alt="remove" />
              </div>
            }
          </>

          {/* text */}
          <textarea className="form-control rounded-4 my-3 shadow-none text-white bg-transparent border-white" name="text" style={{ resize: 'none' }} rows={3} 
            value={cnpText} onChange={handleTextChange} placeholder={`What's new ${loggedInUser && loggedInUser.fname}..?`}
          />

          {/* Menu */}
          <div className='d-flex flex-wrap gap-4'>
            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickFeelingActivity}>
              <img src={`${BASE_URL_STATIC}/create-icon8.png`} style={{ height: '23px', width: '23px' }} alt="feeling/activity" />
              <small className="text-secondary text-white">Feeling/Activity</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickLocation}>
              <img src={`${BASE_URL_STATIC}/create-icon9.png`} style={{ height: '23px', width: '23px' }} alt="Check In" />
              <small className="text-secondary text-white">Check In</small>
            </div>

            <div className="d-flex flex-column align-items-center cursor-pointer" onClick={handleClickMusic}>
              <img src={`${BASE_URL_STATIC}/create-icon11.png`} style={{ height: '23px', width: '23px' }} alt="Music" />
              <small className="text-secondary text-white">Music</small>
            </div>
          </div>
          
          <button type="button" className='btn btn-primary w-100 rounded-pill mt-3 mb-1' onClick={handlePostMeme}
            disabled={cnpSelectedPhotoVideo.length === 0}
          >Post</button>

          {/* Advance Setting */}
          <div className='text-center'>
            <span className='text-white cursor-pointer' onClick={handleClickAdvanceSetting}>Advance Setting</span>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default CnpMemePopup